import { render, staticRenderFns } from "./FcReceivingAgent.vue?vue&type=template&id=f8629092"
import script from "./FcReceivingAgent.vue?vue&type=script&lang=js"
export * from "./FcReceivingAgent.vue?vue&type=script&lang=js"
import style0 from "./FcReceivingAgent.vue?vue&type=style&index=0&id=f8629092&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports